// src/scene/SceneReady.tsx
import { useEffect } from 'react'
import { useProgress } from '@react-three/drei'

export function SceneReadyWatcher({ onReady }: { onReady: () => void }) {
  const { active, progress } = useProgress()

  useEffect(() => {
    // We trigger when active is false (not loading) and progress is 100
    if (!active && progress === 100) {
      const timer = setTimeout(() => {
        requestAnimationFrame(() => {
          onReady()
        })
      }, 100) // Small buffer to ensure DOM is ready for measurement
      return () => clearTimeout(timer)
    }
  }, [active, progress, onReady])

  return null
}